<template lang="pug">
    .formpage.container.mx-auto(v-if="recaptchaSiteKey && formExtensionEnabled")
        //loading(:active="form.loading" :is-full-page="false" :height="40" :width="40" color="#000000")
        validation-observer(v-slot="{ invalid }" ref="observer")
            form(@submit.prevent="submit" ref="form")
                template(
                    v-for="field in form.fields"
                    v-if="! ['email-intro', 'email-content'].includes(field.type)"
                )
                    Field(v-if="field.type === 'multi-select'" :key="field.id" :field="field" v-model="field.values")
                    Field(v-else-if="field.type === 'upload'" :key="field.id" :field="field" v-model="field.files")
                    Field(v-else :key="field.id" :field="field" v-model="field.value")
                .columns
                    .field.column.checkbox
                        validation-provider(name="Datenschutzbestimmungen" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }")
                            .control
                                label
                                    input(type="checkbox" v-model="form.privacy")
                                    |  Mit dem Senden meiner Anfrage stimme ich den <router-link class="underline" target="_blank" to="/datenschutz">Datenschutzbestimmungen</router-link> zu.
                            p.help.text-red-700(v-if="errors && errors.length") {{ errors[0] }}
                            //p.help.text-grey-dark.text-xs.italic(v-else="required") Pflichtfeld
                    .field.column.is-narrow
                        .control
                            button.button.btn-send(type="submit") Absenden
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
//import Loading from 'vue-loading-overlay';

import { cloneDeep, get, uniqueId } from 'lodash';
import { mapGetters } from 'vuex';

import store from '@/store';
import Field from './FormField';

export default {
    name: 'Form',
    components: {
        Error,
        Field
        //Loading
    },
    data() {
        return {
            form: {
                loading: true,
                privacy: false,
                fields: []
            },
            preset: []
        };
    },
    props: {
        section: {
            type: Object
        }
    },
    computed: {
        formExtensionEnabled() {
            return this.cms.enabledExtensionKeys.includes('forms');
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            view: 'currentPage/view',
            error: 'error',
            cms: 'CMS'
        })
    },
    methods: {
        async submit() {
            const valid = await this.$refs.observer.validate();
            if (valid && this.recaptchaSiteKey) {
                this.form.loading = true;
                try {
                    await this.$recaptchaLoaded();
                    await this.$recaptcha('contact');

                    const payload = {
                        cms: { id: parseInt(this.cms.id) },
                        section: { id: parseInt(this.section.id) },
                        fields: this.form.fields
                    };

                    store
                        .dispatch('form/sendFormToApi', payload)
                        .then(() => {
                            // reset form
                            this.form.fields = cloneDeep(this.preset);
                            this.$refs.observer.reset();
                            this.$refs.form.reset();
                        })
                        .finally(() => {
                            this.form.loading = false;
                        });
                } catch (error) {
                    console.error(error);
                    const message = {
                        id: uniqueId(),
                        title: 'Fehler',
                        text:
                            'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                        type: 'danger',
                        autoclose: 5000
                    };
                    store.commit('addMessage', message);
                    this.form.loading = false;
                }
            }
        }
    },
    mounted() {
        const configs = get(this.section, 'contents') || [];
        const sorted = configs.sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        sorted.forEach(config => {
            let type;
            const settings = config.settings || [];
            const setting = settings.find(el => el.key === 'type');
            if (setting) type = setting.value;

            let field = {
                id: uniqueId('new:'),
                key: config.key,
                type: type || config.key,
                title: config.title,
                position: config.position,
                settings: config.settings,
                content: { id: config.id }
            };

            // if (['multi-select', 'upload'].includes(field.type)) field.values = []
            if (field.type === 'multi-select') field.values = [];
            else if (field.type === 'upload') field.files = [];
            else field.value = '';

            this.form.fields.push(field);
            this.preset.push(cloneDeep(field));
        });

        this.form.loading = false;
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, {
                siteKey: this.recaptchaSiteKey,
                loaderOptions: {
                    useRecaptchaNet: true
                }
            });
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

::v-deep
  .field
    padding-bottom: 27px
    margin-bottom: 0

    .btn-send
      @apply transition duration-500 ease-in-out
      background-color: $cc-green
      border-color: $cc-green
      width: 100%
      padding: 15px 22px
      line-height: 34px
      height: auto
      font-size: 24px
      &:hover
        background-color: $cc-green !important
        border-color: $cc-green !important
        opacity: 0.85

    .input, textarea
      font-family: $font-alternative
      background-color: rgba(0,0,0,0.035)
      border: 0
      border-bottom: 2px solid #e0e0e0
      transition: border-color 0.2s ease
      border-radius: 0
      padding: 16px
      font-size: 16px
      height: auto
      width: 100%
      line-height: 1
      &:hover, &:focus, &:focus-visible
        box-shadow: none
        outline: none
      &:focus
        border-color: $cc-green

    textarea
      min-height: 150px
</style>
